const participateForm = document.querySelector('.advent-participation-form');

if (participateForm) {
    const birthdayInput = participateForm.querySelector('input#adventCalendarForm-birthday');
    const birthdayDayInput = participateForm.querySelector('input#adventCalendarForm-birthdayDay');
    const birthdayMonthInput = participateForm.querySelector('input#adventCalendarForm-birthdayMonth');
    const birthdayYearInput = participateForm.querySelector('input#adventCalendarForm-birthdayYear');

    const birthdayInputs = [birthdayDayInput, birthdayMonthInput, birthdayYearInput];
    [...birthdayInputs].forEach((input) => {
        if (!input) {
            return;
        }

        input.addEventListener('change', () => {
            birthdayInput.value = `${birthdayDayInput.value.padStart(2, '0')}.${birthdayMonthInput.value.padStart(
                2,
                '0'
            )}.${birthdayYearInput.value}`;
        });
    });
}
